import { II18n } from '../../../../../models';
import { I18nService } from '../../../../../services';
import React from 'react';

const translations: II18n = {
  es: {
    flag: 'Indicadores relacionales vinculados',
    contextMap: 'Seleccionar mapa de contexto',
  },
  enUS: {
    flag: 'Linked Relational Flags',
    contextMap: 'Select context map',
  },
  ptBR: {
    flag: 'Flags Relacionais Vinculadas',
    contextMap: 'Selecione o mapa de contexto',
  },
};

const translate = (key: string, args?: string[]): string =>
  new I18nService(translations).translate(key, args);

export { translate };
